import { render, staticRenderFns } from "./doctor_taskBox.vue?vue&type=template&id=df5ed770&scoped=true&"
import script from "./doctor_taskBox.vue?vue&type=script&lang=js&"
export * from "./doctor_taskBox.vue?vue&type=script&lang=js&"
import style0 from "./doctor_taskBox.vue?vue&type=style&index=0&id=df5ed770&prod&lang=less&scoped=true&"
import style1 from "./doctor_taskBox.vue?vue&type=style&index=1&id=df5ed770&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5ed770",
  null
  
)

export default component.exports